import React from "react"
import { graphql } from "gatsby"
import { Link } from "gatsby"
import { Helmet } from "react-helmet"
import Img from "gatsby-image"
import Markdown from "../../components/Markdown"
import YoutubeVideo from "../../components/YoutubeVideo"
import style from "./index.module.css";

export default ({ data }) => {
  const content = data.page
  const video = "https://www.youtube.com/watch?v=wr7ppbJ0Rug";
  return (
    <div>
      <Helmet>
        <title>{content.title}</title>
      </Helmet>
      <div className={style.content}>
        <div className={style.text}>
          <h1>{content.title}</h1>
          {content.text.text &&
            <Markdown source={content.text.text} softBreak="br" className={style.text} />
          }
        </div>
        {video &&
          <div className={style.video}>
            <YoutubeVideo videoUrl={video} />
          </div>
        }
      </div>
      <section className={style.list}>
        {content.greenDeals.map((deal, index) => {
          return (
            <article key={index} className={style.deal}>
              <Link to={`/green-deals/${deal.slug}/`}>
                <Img className={style.dealImage} fluid={deal.imageOverview.fluid} />
                <div className={style.dealTextContainer}>
                  <h1 className={style.dealTitle}>{deal.name}</h1>
                  {deal.omschrijving.omschrijving &&
                    <div className={style.dealDescription}>{deal.omschrijving.omschrijving}</div>
                  }
                </div>
              </Link>
            </article>
          )
        })}
      </section>
    </div>
  )
}

export const query = graphql`
  query {
    page: contentfulGreenDealOverzicht {
      title
      metaDescription {metaDescription}
      text {text}
      greenDeals {
        slug
        name
        omschrijving {omschrijving}
        imageOverview {
          fluid(maxWidth: 600) {
            sizes
            aspectRatio
            src
            srcSet
            srcWebp
            srcSetWebp
            aspectRatio
          }
        }
      }
    }
  }
`